/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {StarStruckServerDataParser} from "../StarStruckServerDataParser";
import {IStarStruckGameData} from "./IStarStruckServerData";
import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StarStruckGameMode} from "../../gamemode/StarStruckGameMode";

export class StarStruckParsedGameData extends SpinParsedGameData {

    private readonly _bonusFeatureTriggered:boolean;
    private readonly _bonusWin:boolean;
    private readonly _bonusSymbolWin:number;
    private readonly _bonusSymbolWinMultiplier:number;
    private readonly _playerSelection:number;
    private readonly _bonusValues:number[];
    constructor(rawData:IStarStruckGameData, dataParser:StarStruckServerDataParser) {
        super(rawData, dataParser);

        this._bonusWin = rawData.bonusFeatureTriggered;
        this._bonusFeatureTriggered = rawData.reels[1].indexOf("B") > 0 && rawData.reels[1].indexOf("B") < 4;
        this._bonusSymbolWin = rawData.bonusSymbolWin;
        this._bonusValues = rawData.bonusValues;
        this._bonusSymbolWinMultiplier = rawData.bonusSymbolWinMultiplier;
        this._playerSelection = rawData.playerSelection;
    }

    public get bonusFeatureTriggered():boolean{
        return this._bonusFeatureTriggered;
    }

    public get bonusSymbolWin():number{
        return this._bonusSymbolWin;
    }

    public get bonusWin():boolean{
        return this._bonusWin;
    }

    public get bonusValues():number[]{
        return this._bonusValues;
    }

    public get bonusSymbolWinMultiplier():number{
        return this._bonusSymbolWinMultiplier;
    }

    public get playerSelection():number{
        return this._playerSelection;
    }

    protected isFeatureTotalWin(rawData:IServerData):boolean {
        return this.mode === StarStruckGameMode.STAR_PICK;
    }

    protected isNextFeatureTotalWin(rawData:IServerData):boolean {
        return this.nextMode === StarStruckGameMode.STAR_PICK;
    }

}